import React from 'react';
import { IconProps } from './types';

const TadaIcon: React.FC<IconProps> = props => {
  return (
    <svg
      className={props.className}
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2443 16.985L1.03986 21.3966C0.423917 21.5876 -0.15391 21.0098 0.0371498 20.3939L4.44872 6.18945L15.2443 16.985Z"
        fill="#FFA900"
      />
      <path
        d="M15.679 16.7325C16.7144 15.6972 15.0957 12.3999 12.0636 9.3678C9.03147 6.3357 5.73418 4.717 4.69885 5.75233C3.66352 6.78765 5.28222 10.085 8.31432 13.1171C11.3464 16.1491 14.6437 17.7679 15.679 16.7325Z"
        fill="#FFE0A4"
      />
      <path
        d="M15.1814 16.2337C14.7761 16.6386 13.8519 16.5257 12.6442 15.9236C11.3747 15.2905 9.93219 14.1985 8.58269 12.849C7.23318 11.5 6.14168 10.0575 5.50854 8.78751C4.90654 7.58025 4.79311 6.65564 5.19801 6.25074C5.6029 5.84584 6.52752 5.95927 7.73524 6.56127C9.00478 7.19442 10.4473 8.28592 11.7968 9.63542C13.1463 10.9849 14.2378 12.4274 14.8709 13.6969C15.4729 14.9042 15.5863 15.8288 15.1814 16.2337Z"
        fill="#553800"
      />
      <path
        d="M13.2052 17.6186L10.456 18.4725C9.84608 18.2545 9.24594 17.9928 8.65742 17.6879C7.37626 17.024 6.14343 16.1529 4.99336 15.099C4.80695 14.928 4.60241 14.7332 4.38485 14.5156C3.82283 13.9536 3.17481 13.2391 2.52539 12.38L3.09067 10.5605C4.12267 12.1123 5.23695 13.2675 6.01699 13.982C8.21255 15.9953 10.628 17.2165 13.2047 17.6186H13.2052Z"
        fill="#FFE0A4"
      />
      <path
        d="M8.62135 19.0428L6.45369 19.7159C5.21436 19.06 4.02151 18.2097 2.90584 17.1875C2.71943 17.0164 2.51489 16.8216 2.29733 16.6041C2.04072 16.3475 1.76692 16.0597 1.48242 15.7408L2.01469 14.0273C2.71989 14.9008 3.40185 15.587 3.92947 16.0709C5.4003 17.4199 6.97015 18.4129 8.62089 19.0428H8.62135Z"
        fill="#FFE0A4"
      />
      <path
        d="M4.69596 20.2604L2.79327 20.8512C2.11317 20.3845 1.45213 19.8578 0.81666 19.2753C0.71067 19.1777 0.599103 19.0731 0.482422 18.9606L0.990519 17.3252C1.29965 17.6483 1.58787 17.9263 1.84076 18.1582C2.75561 18.9973 3.70905 19.6988 4.69596 20.2604Z"
        fill="#FFE0A4"
      />
      <path
        d="M8.26446 7.99001L7.5918 7.31735C8.66006 6.2491 9.27042 4.87635 9.40616 3.2377C9.50936 1.99093 9.28437 1.05005 9.28205 1.04075L10.2057 0.8125C10.2164 0.855732 10.467 1.88727 10.3568 3.28093C10.2104 5.139 9.48659 6.76742 8.26399 7.99001H8.26446Z"
        fill="#FFF1D4"
      />
      <path
        d="M13.6121 14.011L12.9395 13.3383C14.2564 12.0214 16.1201 11.3585 18.3286 11.4222C19.9682 11.4696 21.2154 11.8949 21.268 11.9135L20.957 12.8126L21.1127 12.363L20.9574 12.8126C20.9458 12.8084 19.7744 12.4114 18.2752 12.3723C16.319 12.3212 14.7506 12.8725 13.6121 14.011Z"
        fill="#FFDB94"
      />
      <path
        d="M10.3223 7.02955C10.6672 6.45638 11.1204 6.30669 11.4514 6.19744C11.7317 6.10494 11.9005 6.04915 12.0636 5.7786C12.2264 5.50805 12.1966 5.33233 12.1469 5.04179C12.0883 4.69826 12.0079 4.22781 12.3528 3.65463C12.6977 3.08146 13.151 2.93177 13.482 2.82253C13.7623 2.73002 13.931 2.67423 14.0942 2.40322C14.2569 2.1322 14.2271 1.95695 14.1774 1.66594C14.1188 1.32241 14.0384 0.851964 14.3833 0.27832L15.1987 0.768753C15.036 1.03977 15.0657 1.21502 15.1155 1.50603C15.1741 1.84956 15.2545 2.32001 14.9096 2.89365C14.5646 3.46683 14.1114 3.61651 13.7804 3.72576C13.5001 3.81827 13.3309 3.87405 13.1682 4.14507C13.0055 4.41562 13.0352 4.59134 13.085 4.88188C13.1435 5.22541 13.224 5.69586 12.879 6.26903C12.5341 6.84221 12.0808 6.9919 11.7499 7.10114C11.4696 7.19365 11.3008 7.24943 11.1376 7.51999L10.3223 7.02955Z"
        fill="#FFDB94"
      />
      <path
        d="M14.2417 9.57943L13.7754 8.75011C14.376 8.41262 14.8595 8.50931 15.2123 8.58043C15.5182 8.64179 15.7027 8.67898 15.9956 8.51396C16.2889 8.3494 16.3531 8.17228 16.4595 7.87942C16.5822 7.54099 16.7505 7.07799 17.3516 6.74003C17.9527 6.40254 18.4357 6.49923 18.7885 6.57036C19.0944 6.63172 19.2789 6.66891 19.5723 6.50388C19.8656 6.33885 19.9297 6.16221 20.0362 5.86888C20.1589 5.53045 20.3272 5.06745 20.9283 4.72949L21.3945 5.55881C21.1012 5.72384 21.037 5.90049 20.9306 6.19382C20.8079 6.53224 20.6396 6.99524 20.0385 7.3332C19.4374 7.67116 18.9545 7.574 18.6016 7.50288C18.2957 7.44151 18.1112 7.40432 17.8183 7.56935C17.525 7.73391 17.4608 7.91103 17.3544 8.20389C17.2317 8.54231 17.0634 9.00532 16.4623 9.34328C15.8617 9.68077 15.3782 9.58361 15.0254 9.51295C14.7195 9.45159 14.5354 9.4144 14.2421 9.57943H14.2417Z"
        fill="#FFF1D4"
      />
      <path
        d="M20.2724 9.64252C20.5351 9.64252 20.748 9.42961 20.748 9.16696C20.748 8.90432 20.5351 8.69141 20.2724 8.69141C20.0098 8.69141 19.7969 8.90432 19.7969 9.16696C19.7969 9.42961 20.0098 9.64252 20.2724 9.64252Z"
        fill="#FFF1D4"
      />
      <path
        d="M18.1552 15.1923C18.4179 15.1923 18.6308 14.9794 18.6308 14.7168C18.6308 14.4541 18.4179 14.2412 18.1552 14.2412C17.8926 14.2412 17.6797 14.4541 17.6797 14.7168C17.6797 14.9794 17.8926 15.1923 18.1552 15.1923Z"
        fill="#FFDB94"
      />
      <path
        d="M22.5244 11.1552C22.787 11.1552 22.9999 10.9423 22.9999 10.6797C22.9999 10.417 22.787 10.2041 22.5244 10.2041C22.2617 10.2041 22.0488 10.417 22.0488 10.6797C22.0488 10.9423 22.2617 11.1552 22.5244 11.1552Z"
        fill="#FFDB94"
      />
      <path
        d="M18.6572 4.59857C18.9198 4.59857 19.1328 4.38566 19.1328 4.12302C19.1328 3.86038 18.9198 3.64746 18.6572 3.64746C18.3946 3.64746 18.1816 3.86038 18.1816 4.12302C18.1816 4.38566 18.3946 4.59857 18.6572 4.59857Z"
        fill="#FFF1D4"
      />
      <path
        d="M11.6611 1.09955C11.9237 1.09955 12.1367 0.886637 12.1367 0.623994C12.1367 0.361351 11.9237 0.148438 11.6611 0.148438C11.3985 0.148438 11.1855 0.361351 11.1855 0.623994C11.1855 0.886637 11.3985 1.09955 11.6611 1.09955Z"
        fill="#FFF1D4"
      />
      <path
        d="M14.958 5.20209C15.2206 5.20209 15.4335 4.98918 15.4335 4.72653C15.4335 4.46389 15.2206 4.25098 14.958 4.25098C14.6953 4.25098 14.4824 4.46389 14.4824 4.72653C14.4824 4.98918 14.6953 5.20209 14.958 5.20209Z"
        fill="#FFDB94"
      />
      <path
        d="M11.3584 11.0888C11.621 11.0888 11.8339 10.8759 11.8339 10.6133C11.8339 10.3506 11.621 10.1377 11.3584 10.1377C11.0957 10.1377 10.8828 10.3506 10.8828 10.6133C10.8828 10.8759 11.0957 11.0888 11.3584 11.0888Z"
        fill="#FFDB94"
      />
      <path
        d="M6.38376 3.35346C6.6464 3.35346 6.85932 3.14054 6.85932 2.8779C6.85932 2.61526 6.6464 2.40234 6.38376 2.40234C6.12112 2.40234 5.9082 2.61526 5.9082 2.8779C5.9082 3.14054 6.12112 3.35346 6.38376 3.35346Z"
        fill="#FFDB94"
      />
    </svg>
  );
};

export default TadaIcon;
